module.exports = __webpack_public_path__ + "static/media/slide3.e8a53af9.png";